export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/book_trailers.9b67428.svg";